import { ProductGalleryNavigation } from "theme";

class InfiniteProductCarousel extends ProductGalleryNavigation {
  connectedCallback() {
    super.connectedCallback();
    this.initInfiniteScroll();
  }

  initInfiniteScroll() {
    this.originalCells = [...this.items];
    this.newItems = [...this.originalCells];

    this.isInfinite = this.shouldEnableInfiniteScroll();
    if (!this.isInfinite) return;

    this.enableInfiniteScroll();
    this.newItems = Array.from(this.querySelectorAll("button"));
    this.newItems.forEach((item) => {
      item.addEventListener("click", () => {
        this.onButtonClicked(this.newItems.indexOf(item));
      });
    });
  }

  shouldEnableInfiniteScroll() {
    // Check if all items fit within the visible width
    const totalItemsHeight = this.originalCells.reduce(
      (total, cell) => total + cell.offsetHeight,
      0
    );
    return totalItemsHeight > this.clientHeight; // Enable only if scrolling is needed
  }

  enableInfiniteScroll() {
    // Duplicate items before and after for seamless scrolling
    this.originalCells.forEach((cell) => {
      const clone = cell.cloneNode(true);
      clone.setAttribute("data-clone", "true");
      if (clone.getAttribute("aria-current") === "true") clone.setAttribute("aria-current", false);
      this.appendChild(clone);
    });

    [...this.originalCells].reverse().forEach((cell) => {
      const clone = cell.cloneNode(true);
      clone.setAttribute("data-clone", "true");
      if (clone.getAttribute("aria-current") === "true") clone.setAttribute("aria-current", false);
      this.insertBefore(clone, this.firstChild);
    });

    // Set correct scroll position
    setTimeout(() => {
      this.scrollTop = this.originalCells[0].offsetTop;
    }, 50);

    this.addEventListener("scroll", () => {
      const lastOriginalCell = this.originalCells[this.originalCells.length - 1];
      if (this.scrollTop <= 0) {
        this.scrollTop = lastOriginalCell.offsetTop + lastOriginalCell.clientHeight;
      } else if (this.scrollTop + this.clientHeight >= this.scrollHeight - 1) {
        this.scrollTop =
          lastOriginalCell.offsetTop - this.clientHeight + lastOriginalCell.clientHeight;
      }
    });
  }

  onButtonClicked(newIndex) {
    if (!this.isInfinite) {
      const index = this.carousel.originalCells.length + newIndex;
      return super.onButtonClicked(index);
    }

    if (this.carousel.isScrollable) {
      this.carousel.select(newIndex);
      this.onNavigationChange(newIndex);
    } else {
      this.carousel.cells[newIndex]?.scrollIntoView({ block: "start", behavior: "smooth" });
      this.onNavigationChange(newIndex);
    }
  }

  onNavigationChange(index) {
    let newIndex = index;
    if (!this.isInfinite) {
      newIndex = this.carousel.selectedIndex % this.carousel.originalCells.length;
    }
    const target = this.newItems[newIndex];
    this.newItems.forEach((button) => button.setAttribute("aria-current", "false"));
    target.setAttribute("aria-current", "true");
    this.scrollTo({
      top: target.offsetTop,
      behavior: "smooth",
    });
  }
}

window.customElements.define("infinite-product-carousel", InfiniteProductCarousel);
